"use client";

import { Stepper, Step as StepperStep } from "cy-ui/components/stepper";
import { Step } from "cy-remittance/registration/models";

const indexMap: Record<Step, number> = {
  start: 1,
  accountType: 2,
  accountLimit: 2,
  personal: 3,
  marketing: 3,
  password: 4,
  otp: 4,
  done: 5,
};
const steps: StepperStep[] = [
  { label: "Login", description: "Setup login info..." },
  { label: "Account", description: "Choose your account type..." },
  { label: "Profile", description: "Setup your profile..." },
  { label: "Password", description: "Set a password..." },
  { label: "Done", description: "Registration complete..." },
];
export function StepperSection({ step }: { step: Step }) {
  const stepperStep = indexMap[step];
  return <Stepper className="w-full" steps={steps} currentStep={stepperStep} />;
}
